import { Entity } from './entity';

export class ParentEntity {
  parent: Entity = new Entity();
  child: Entity;
  ownership: number;
}
